import React, { createContext, useContext, useState } from 'react';

// Create the UserContext
const UserContext = createContext();

// UserContext Provider
export const UserProvider = ({ children }) => {
  const [admin, setAdmin] = useState(false); // Tracks if the user is an admin
  const [isAdmin, setIsAdmin] = useState(false); // Tracks if admin actions are allowed

  // Define functions to update the state
  const updateAdmin = (value) => setAdmin(value);
  const updateIsAdmin = (value) => setIsAdmin(value);

  // Context value to be shared
  const value = {
    admin,
    isAdmin,
    updateAdmin,
    updateIsAdmin,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

// Custom hook to use UserContext
export const useUser = () => useContext(UserContext);
